import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-one-two',
  templateUrl: './two-one-two.component.html',
  styleUrls: ['./two-one-two.component.scss']
})
export class TwoOneTwoComponent implements OnInit {
 
  constructor() { }

  ngOnInit(): void {
  }

}
